import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface PayMyBillPolicy {
  policyNumber: string;
  policyStatus: string;
  policyType: string;
  dueAmount: number;
  dueDate: string;
}

export interface PayMyBill {
  policy?: PayMyBillPolicy;
  paymentCompleted: boolean;
  policyNotFound?: boolean;
}

const initialState: PayMyBill = {
  paymentCompleted: false,
};
export const payMyBillSlice = createSlice({
  name: 'payMybill',
  initialState,
  reducers: {
    updatePolicy: (state, action: PayloadAction<PayMyBillPolicy | undefined>) => {
      state.policy = action.payload;
      if (!action.payload) {
        state.paymentCompleted = false;
        state.policyNotFound = false;
      }
    },
    updatePaymentCompleted: (state, action: PayloadAction<boolean>) => {
      state.paymentCompleted = action.payload;
    },
    updatePolicyNotFound: (state, action: PayloadAction<boolean>) => {
      state.policyNotFound = action.payload;
    },
  },
});

export const { updatePaymentCompleted, updatePolicyNotFound, updatePolicy } =
  payMyBillSlice.actions;
